// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Client from "@apollo/client";
import * as ApolloClient__Link_Core_Types from "./ApolloClient__Link_Core_Types.bs.js";

var Static = {};

var Js_ = {
  Static: Static
};

function make(requestHandler) {
  return new Client.ApolloLink(ApolloClient__Link_Core_Types.RequestHandler.toJs(requestHandler));
}

function concat(prim0, prim1) {
  return prim0.concat(prim1);
}

function from(prim0, prim1) {
  return prim0.from(prim1);
}

function setOnError(prim0, prim1) {
  prim0.onError(prim1);
}

function split(t, test, whenTrue, whenFalse) {
  return t.split((function (jsOperation) {
                return Curry._1(test, ApolloClient__Link_Core_Types.Operation.fromJs(jsOperation));
              }), whenTrue, whenFalse);
}

var FetchResult;

var GraphQLRequest;

var Observable;

var Operation;

var RequestHandler;

var Static$1;

export {
  FetchResult ,
  GraphQLRequest ,
  Observable ,
  Operation ,
  RequestHandler ,
  Js_ ,
  Static$1 as Static,
  make ,
  concat ,
  from ,
  setOnError ,
  split ,
}
/* @apollo/client Not a pure module */
